// Configuración de entorno para la aplicación
import { resolveApiUrl } from './apiUrl';

const isProduction = process.env.NODE_ENV === 'production';
const apiUrl = resolveApiUrl();

export const environment = {
  production: isProduction,
  apiUrl,
  apiBaseUrl: `${apiUrl}/api`,
  petflixApiUrl: process.env.REACT_APP_PETFLIX_API_URL || 'https://staging.petflix.io',
  contentBaseUrl:
    process.env.REACT_APP_CONTENT_BASE_URL || 'https://dev.petflix.io/content',
  petContestAccessKey: process.env.REACT_APP_PET_CONTEST_ACCESS_KEY || '',
  subdomain: typeof window !== 'undefined' ? window.location.hostname.split('.')[0] : 'localhost',
  appName: 'Pet Contest Management',
  version: '1.0.0'
};

// Configuración de rutas
export const routes = {
  home: '/',
  contest: '/pet_contest',
  contestVote: '/contest_vote',
  contestWinners: '/contest_winners',
  contestParticipant: '/contest_participant',
  contestCouponPasses: '/contest_couponpasses',
  contestPassCodes: '/contest_passcodes',
  login: '/login',
  otp: '/otp-verification',
  seoConfig: '/seo-config',
  petWinnersAndCoupons: '/pet_winners_and_coupons',
  platformSettings: '/platform_settings',
  payoutsCenter: '/payouts_center',
};

// Configuración de la aplicación
export const appConfig = {
  title: 'Pet Contest Management',
  description: 'Panel de Administración de Concursos de Noah\'s Ark',
  defaultLanguage: 'es',
  supportedLanguages: ['es', 'en']
};

export const appStoreUrls = {
  ios: process.env.REACT_APP_IOS_STORE_URL || 'https://apps.apple.com/co/app/noahs-ark-pet-connect/id6473087528?l=en-GB',
  android: process.env.REACT_APP_ANDROID_STORE_URL || 'https://play.google.com/store/apps/details?id=net.noahsarkpets&pcampaignid=web_share',
};
